import React from 'react';
import './index.scss';
import Navbar from './components/navbar';
import { MenuContextProvider } from 'context/MenuContext';
import CustomConfig from 'models/CustomConfig';
import { setupInlineManual } from 'utils/inlineConfig';
import Container from 'components/notifications/container';
import { NotificationContextProvider } from 'context/NotificationContext';

function Biobar(props : CustomConfig) : JSX.Element {

  const Element = (config : CustomConfig) : JSX.Element => {
    if(config.render === 'notifications')
      return <NotificationContextProvider><Container /></NotificationContextProvider>;

    setupInlineManual(config.inlineManualUrl);
    return <MenuContextProvider><Navbar {...config} /></MenuContextProvider>;
  };

  return(
    <React.StrictMode>
      <Element {...props} />
    </React.StrictMode>
  );
}

export default Biobar;

